export default "__VITE_ASSET__2dfc2ba7__"